import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-array-object-editor',
  templateUrl: './array-object-editor.component.html',
  styleUrls: ['./array-object-editor.component.scss']
})
export class ArrayObjectEditorComponent implements OnInit {

  @Input() sampleObject: any[] = [];
  @Input() title = '';
  newColumnName = '';
  addRow() {
    const newRow: any = {};
    const keys = this.objectKeys(this.sampleObject[0]);
    keys.forEach(key => {
      if (typeof this.sampleObject[0][key] === 'object') {
        newRow[key] = {};
        const subKeys = this.objectKeys(this.sampleObject[0][key]);
        subKeys.forEach(subKey => {
          newRow[key][subKey] = '';
        });
      } else {
        newRow[key] = '';
      }
    });
    this.sampleObject.push(newRow);
    localStorage.setItem(this.title, JSON.stringify(this.sampleObject));
  }



  addColumn() {
    this.sampleObject.forEach(obj => {
      obj[this.newColumnName] = '';
    });
    localStorage.setItem(this.title, JSON.stringify(this.sampleObject));
  }
  getSampleObject(): any[] {
    return [
      {
        name: 'John Doe',
        age: 30,
        address: {
          street: '123 Main St',
          city: 'New York',
          state: 'NY'
        }
      },
      {
        name: 'Jane Doe2',
        age: 25,
        address: {
          street: '456 Elm St',
          city: 'Los Angeles',
          state: 'CA'
        }
      },
    ]
  }

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    console.log(this)
    this.route.queryParams.subscribe(params => {
      this.title = params['title'] || this.title;
      this.sampleObject = JSON.parse(localStorage.getItem(this.title));
      this.init();  
    });
  }

  init() {
    console.log('init', this);
    if(! this.title){
      this.title = 'sampleObject';
    }
    if (!this.sampleObject) {
      const storedSampleObject = localStorage.getItem(this.title);
      if (storedSampleObject) {
        this.sampleObject = JSON.parse(storedSampleObject);
      }
    }

  }

  arrayKeys(arr: any[]): string[] {
    const keys: string[] = [];
    arr.forEach(obj => {
      const objKeys = this.objectKeys(obj);
      objKeys.forEach(key => {
        if (!keys.includes(key)) {
          keys.push(key);
        }
      });
    });
    return keys;
  }

  objectKeys(obj: any): string[] {
    const keys: string[] = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) {
          const subKeys = this.objectKeys(obj[key]);
          subKeys.forEach(subKey => {
            keys.push(`${key}.${subKey}`);
          });
        } else {
          keys.push(key);
        }
      }
    }
    return keys;
  }

  updateObjectValue(obj: any, key: string, value: any) {
    // address.street
    //['address', 'street']
    // length = 2
    const keys = key.split('.');
    let currentObj = obj; // {name: "", address: {street: ""}}
    let currentKey = keys[0]; // address

    for (let i = 0; i < keys.length - 1; i++) { // length = 2, i = 1, length - 1 = 1
      if (!currentObj[currentKey]) {
        currentObj[currentKey] = {};
      }
      currentObj = currentObj[currentKey]; // currentObj = currentObj['address']
      currentKey = keys[i + 1]; // currentKey = 'street'
    }

    currentObj[currentKey] = value;
    localStorage.setItem(this.title, JSON.stringify(this.sampleObject));
  }

  onJsonFileSelected(event: any) {
    this.title = prompt('Enter a title for this data');
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const jsonData = e.target.result;
        this.sampleObject = JSON.parse(jsonData);
        localStorage.setItem(this.title, JSON.stringify(this.sampleObject));
      };
      reader.readAsText(file);
    }
  }
  onFileSelected(event: any) {
    this.title = prompt('Enter a title for this data');
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const csvData = e.target.result;
        this.parseCsvData(csvData);
      };
      reader.readAsText(file);
    }
  }

  getValues(obj: any, key: string): any {
    // address.street
    //['address', 'street']
    const keys = key.split('.');
    let currentObj = obj;
    let currentKey = keys[0];
    for (let i = 0; i < keys.length - 1; i++) { // length = 2, i = 0, length - 1 = 1
      // currentObj = currentObj['address']
      currentObj = currentObj[currentKey];//
      currentKey = keys[i + 1]; // currentKey = 'street'
    }
    return currentObj[currentKey];
  }

  parseCsvData(csvData: string) {
    const lines = csvData.split('\n');
    const result = [];
    const headers = lines[0].split(',');

    for (let i = 1; i < lines.length; i++) {
      const obj: any = {};
      const currentline = lines[i].split(',');

      for (let j = 0; j < headers.length; j++) {
        if (!currentline[j]) {
          continue;
        }
        obj[headers[j].trim()] = currentline[j].trim();
      }
      result.push(obj);
    }

    this.sampleObject = result;
    localStorage.setItem(this.title, JSON.stringify(this.sampleObject));
  }
  
  downloadAsCSV() {
    const headers = this.objectKeys(this.sampleObject[0]).join(',');
    const keys = this.objectKeys(this.sampleObject[0]);
    const rows = this.sampleObject.map(obj => {
      const row =  keys.map(key => this.getValues(obj, key) ||'')
      return row.join(',');
    });
    const csvContent = [headers, ...rows].join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.title}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  downloadAsJSON() {
    const jsonContent = JSON.stringify(this.sampleObject, null, 2);
    const blob = new Blob([jsonContent], { type: 'application/json;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.title}.json`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
